let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("830Zv")).then(() => parcelRequire('lC5h8'));